import {ModelXhr} from '../helpers/model/xhr.js';
import {categoriesMapping} from "../components/categories/categories_mapping.js";
import {config} from '../config.js';
import {GeoModel} from "../components/map/geo-model.js";
import {countryNames} from "../components/map/country_names-mapping.js";


class ModelCountriesMain extends ModelXhr{
    static modelName = "ModelCountriesMain";

    static getSelect(input){
        // return input
    }

    constructor(selectData){
        super(selectData, {
            endpoint: config.api_endpoint,
            // endpoint: 'http://localhost:3000/server/data.json',
            method: 'GET'
        });

        this.geoModelListener = null;
        this.cacheEnabled = true;
    }

    init() {
        super.init();
        this.geoModelListener = GeoModel.addConsumer(GeoModel, {}, (model) => {
            if(model.status === GeoModel.Status.SUCCESS && !this.geoModel){
                this.geoModel = model;
                this.trigger();
            }
        });
    }

    setIdle() {
        super.setIdle();
        if(this.geoModelListener){
            GeoModel.removeConsumer(
                GeoModel, this.geoModelListener.instanceId, this.geoModelListener.listenerId);
        }
    }

    getSelect(input){
        return ModelCountriesMain.getSelect(input);
    }


    getDataFromResponse(data){
        try{
            const response = JSON.parse(data);
            if(! response){ // status is used in older projects
                let error = 'The server returned an unknown error';
                this.onFailure(error);
                return null;
            }
            return response;
        }catch(e){
            if(this.request && this.request.aborted){
                console.warn('Cannot process request, probably because it was aborted. Exception: ' +
                    e.message);
                this.status = 'waiting';
            }else{
                this.onFailure(e);
            }
        }

        return null;        
    }


    getData(){
        const values = [];
        if (this.status === ModelCountriesMain.Status.SUCCESS && this.data && this.geoModel) {
            const countries = this.geoModel.getCountryData();

            for (const [iso3, country] of countries.entries()) {
                const foundCountry = this.data.find((c)=>c.country_code === country.id2);

                if(foundCountry){
                    const categories = [];
                    for(const [key, category] of categoriesMapping.entries()){
                        if(foundCountry[`category_${category.id}`] === true){
                            // If category 8 is true while there are other categories selected aswell skip category 8.
                            if(key === 7 && foundCountry.category_8 === true && categories.length > 0){
                                break;
                            }
                            categories.push(category.id)
                        }
                    }

                    values.push({
                        ...foundCountry,
                        categories,
                        hasCountryDetails: true,
                        is_active: foundCountry.is_pf_active_in_this_country ? true : false
                    });
                }else{
                    values.push({
                        hasCountryDetails: false,
                        country_code: country.id2,
                        country_name: countryNames[iso3],
                        categories: [8],
                        is_active: false
                    });
                }

            }
        }

        return {
            status: this.status,
            data: {
                raw: this.data,
                values: values
            },
        };
    }
}

export {ModelCountriesMain};
